import type { AppProps } from 'next/app';
import { MDXProvider } from '@mdx-js/react';
import { Provider as BalancerProvider } from 'react-wrap-balancer';

import '../styles/globals.css';
import '@fontsource-variable/inter';

import { markdownComponents } from '../lib/copyRendering';
import { TawkTo } from '../components/TawkTo';

export default function MyApp({ Component, pageProps }: AppProps) {
  return (
    <MDXProvider components={markdownComponents}>
      <BalancerProvider>
        <TawkTo />
        <Component {...pageProps} />
      </BalancerProvider>
    </MDXProvider>
  );
}
